import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { ReportService } from 'src/app/services/report.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-accounts-csv-report',
  templateUrl: './accounts-csv-report.component.html',
  styleUrls: ['./accounts-csv-report.component.scss'],
})
export class AccountsCsvReportComponent implements OnInit {
  reportForm: FormGroup;
  isLoadingCsv = false;
  maxMonth: string;

  constructor(
    private fb: FormBuilder,
    private reportService: ReportService,
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    const currentMonth = `${yyyy}-${mm}`;

    this.maxMonth = currentMonth;

    this.reportForm = this.fb.group({
      month: [
        currentMonth,
        [
          Validators.required,
          this.monthNotFutureValidator,
          this.yearNotBefore2020Validator,
        ],
      ],
    });

    this.reportForm
      .get('month')
      ?.statusChanges.subscribe((status) => this.handleStatusChange(status));
  }

  private handleStatusChange(status: string): void {
    const control = this.reportForm.get('month');
    if (status === 'INVALID' && control?.errors) {
      if (control.errors['futureMonth']) {
        this.loginService.showMessage(
          'Não é permitido escolher mês futuro.',
          3000
        );
        control.setValue(this.maxMonth);
      } else if (control.errors['yearTooEarly']) {
        this.loginService.showMessage(
          'Ano não pode ser anterior a 2020.',
          3000
        );
        control.setValue(this.maxMonth);
      }
    }
  }

  private monthNotFutureValidator(
    control: AbstractControl
  ): ValidationErrors | null {
    const val: string = control.value;
    if (!val) return null;
    const [y, m] = val.split('-').map(Number);
    const selected = new Date(y, m - 1);
    const now = new Date();
    if (
      selected.getFullYear() > now.getFullYear() ||
      (selected.getFullYear() === now.getFullYear() &&
        selected.getMonth() > now.getMonth())
    ) {
      return { futureMonth: true };
    }
    return null;
  }

  private yearNotBefore2020Validator(
    control: AbstractControl
  ): ValidationErrors | null {
    const val: string = control.value;
    if (!val) return null;
    const year = Number(val.split('-')[0]);
    return year < 2020 ? { yearTooEarly: true } : null;
  }

  openPicker(input: HTMLInputElement): void {
    (input as any).showPicker?.();
  }

  onDownloadCsv(): void {
    if (this.reportForm.invalid) return;

    this.isLoadingCsv = true;
    const selectedMonth = this.reportForm.value.month;
    const dateParam = `${selectedMonth}-01`;

    this.reportService.downloadAccountsCsv(dateParam).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const [year, month] = selectedMonth.split('-');
        const a = document.createElement('a');
        a.href = url;
        a.download = `Relatorio-Contas-${month}-${year}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.isLoadingCsv = false;
      },
      error: () => (this.isLoadingCsv = false),
    });
  }

  get formattedMonth(): string {
    const val = this.reportForm.value.month;
    if (!val) return '';
    const [year, month] = val.split('-');
    return `${month}/${year}`;
  }
}
